import React from "react";
import AvailabilityHeadingCell from "../AvailabilityHeadingCell";
import {TableRow} from 'material-ui/Table';
import * as DateUtil from '../../utils/DateUtil';

const AvailabilityHeadingMobile = ({criteria, currency, showRate, displayNoOfNights}) => {
  const availabilityCells = [];

  let startDate = DateUtil.localDateFromString(criteria.startDate);

  let styles = {
    customEmptyStyle: {
      width: 160,
      height: 40,
      paddingRight: 0,
      paddingLeft: 0,
    },
    weekendStyle: {
      backgroundColor: "#EEEEEE",
      color: "#757575",
    },
    headingStyle: {
      height: 40,
    }
  };

  for (let i = 0; i < displayNoOfNights; i++) {
    let isWeekend = startDate.dayOfWeek().value() === 6
        || startDate.dayOfWeek().value() === 7;

    availabilityCells.push(<AvailabilityHeadingCell
        style={styles.headingStyle}
        key={i}
        heading={DateUtil.localDateToString(startDate, ' dd')}
        dayOfWeek={DateUtil.getDayOfWeek(startDate)}
        className={isWeekend ? "weekend" : "week"}
        />);
    startDate = startDate.plusDays(1);
  }

  return (
      <TableRow>
        <AvailabilityHeadingCell style={styles.customEmptyStyle} heading={'Room Type'} className="roomType" />
        {availabilityCells}
        <AvailabilityHeadingCell dayOfWeek={showRate ? 'Currency' : ''}
                                 heading={showRate ? currency : ''}
                                 className="book" />
      </TableRow>
  )
};

export default AvailabilityHeadingMobile;


// WEBPACK FOOTER //
// ./src/components/mobile/AvailabilityHeadingMobile.js